const axisLabel = {
  fontSize: "0.75rem",
  px: 2,
  cursor: "pointer",
}

export const styles = {
  axisLabel: axisLabel,
  axisLabelSelected: {
    ...axisLabel,
    fontWeight: "bold",
  },
  axisContainer: {
    alignContent: "center",
    display: "flex",
    justifyContent: "center",
    width: "100%",
  },
}
